import { render, staticRenderFns } from "./NumericList.vue?vue&type=template&id=2fedd5c8&scoped=true"
import script from "./NumericList.vue?vue&type=script&lang=js"
export * from "./NumericList.vue?vue&type=script&lang=js"
import style0 from "./NumericList.vue?vue&type=style&index=0&id=2fedd5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fedd5c8",
  null
  
)

export default component.exports